import { render, staticRenderFns } from "./ArtifactReceivers.vue?vue&type=template&id=2101485c&"
import script from "./ArtifactReceivers.vue?vue&type=script&lang=js&"
export * from "./ArtifactReceivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports